import script from "./SeeReminders.vue?vue&type=script&setup=true&lang=js"
export * from "./SeeReminders.vue?vue&type=script&setup=true&lang=js"

import "./SeeReminders.vue?vue&type=style&index=0&id=98775588&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98775588"]])

export default __exports__